import { render, staticRenderFns } from "./AlertPostponeModal.vue?vue&type=template&id=20b0abdf&scoped=true&"
import script from "./AlertPostponeModal.vue?vue&type=script&lang=ts&"
export * from "./AlertPostponeModal.vue?vue&type=script&lang=ts&"
import style0 from "./AlertPostponeModal.vue?vue&type=style&index=0&id=20b0abdf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0abdf",
  null
  
)

export default component.exports